import loadable from '@hh.ru/loadable-component';

export default loadable(
    () => import('../../pages/VacancyConstructorTemplatePreview/VacancyConstructorTemplatePreview.route')
);
